import { ImageLoader } from '../../../ImageLoader';
import { useLocale } from '../../../../i18n/locale';
import { getManualImageAsset, imageBaseNames } from './imageAssets';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import { useCustomIntl } from '../../../../i18n/i18n';
import useDarkMode from '@rio-cloud/rio-uikit/useDarkMode';

export const GetStartedWelcomeChapter: React.FC = () => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();
  const isDarkMode = useDarkMode();

  const welcomeImage = getManualImageAsset(
    imageBaseNames.getStarted_welcome,
    locale,
    isDarkMode,
  );

  return (
    <div className={'row'}>
      <ChapterHeadline messageId={'userManual.getStarted.welcome.headline'} />
      <div
        className={
          'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
        }
      >
        <ChapterText
          colSize={12}
          colSizeMd={6}
          messageId={'userManual.getStarted.welcome.text'}
        />
        <div className="col-xs-12 col-md-6 margin-bottom-25">
          <ImageLoader
            src={welcomeImage}
            className={'border'}
            alt={formatMessage({
              id: 'userManual.getStarted.welcome.headline',
            })}
            enlargeable
          />
        </div>
      </div>
    </div>
  );
};
